import {initAccordion} from '$c3template/frontend/accordion.js';
import {fakeUploadField} from '$c3template/frontend/form.js';
import { mobileTouchFix } from '$c3template/frontend/mobile-touch-fix.js';
import {overrideMobileNav} from '$c3template/frontend/override-mobile-nav.js';
import {initMobileMenu} from '$c3template/frontend/menu.js';
import {initFade} from '$c3template/frontend/fade.js';
import {initMobileNav} from '$c3template/frontend/check-mobile-nav.js';

let headerPadding = 30;

/**
 *
 * @param {{
 *     headerPadding: number
 * }} config
 */
export function configure(config) {
    headerPadding = config.headerPadding;
}

overrideMobileNav(headerPadding);

$(function () {
    mobileTouchFix($('.page-header nav'));
    initAccordion();
    initMobileMenu();
    fakeUploadField();
    initMobileNav();

});

$(window).on('load', function () {
    initFade();
});